import { render, staticRenderFns } from "./tongueRoundS.vue?vue&type=template&id=22836518&"
import script from "./tongueRoundS.vue?vue&type=script&lang=js&"
export * from "./tongueRoundS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports